<div class="overlay database-selector ">

    <div class="overlay-header">
        <h2>Database Selector</h2>
    </div>
    <div class="section-divider"></div>
    <section>
        <f-alert variant="error" [ngClass]="{'error-wrapper hide': ! listApiFailure}">
            {{ errorMessage}}<button class="btn-alert" (click)="getTBALifeCycleList()"> Try again</button>
        </f-alert>
        <f-alert variant="error" [ngClass]="{'error-wrapper hide': ! isDatabaseSelectorApiFailure}">
            {{ errorMessage}}
        </f-alert>
    </section>
    <form [formGroup]="databaseSelectorForm" autocomplete="off" id="dbSelecterForm" class="form-scroll">
        <div class="overlay-body">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h6>Select a client <input type="text" value="test" class="opacity-none" /></h6>
                    </div>

                </div>

                <div class="row row-bottom-space">
                    <div class="col-md-6">
                        <app-alight-smart-search-drop-down [group]="databaseSelectorForm" [controlName]="'clientName'"
                        [required]="true" description="clientName" [clearSeleAvailable]="true"  (clearEvent)="onClearSelection($event)" [disable]="false" label="Client"
                        [value]="'clientName'" [list]="                         
                           customerService.clients                             
                      " (changeEvent)="onClientDropDownChange($event)">
                    </app-alight-smart-search-drop-down>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <h4>Default Configurations</h4>
                    </div>
                </div>
                <div class=" default-section">
                    <div class="row default-config-label">
                        <div class="col-md-4 disabled-item">
                            <div class="data-label" [ngClass]="{'disabledLink': ! isClientSelected}">UDP Database</div>
                           
                        </div>
                        <div class="col-md-4">
                            <div class="data-label"
                                [ngClass]="{'disabledLink': ! isTBAClient || ! isClientSelected}">TBA Lifecycle
                            </div>
                           
                        </div>
                        <div class="col-md-4">
                            <div class="data-label"
                                [ngClass]="{'disabledLink': ! isTBAClient || ! isClientSelected}">Trans ID</div>
                            
                        </div>
                    </div>
                    <div class="row default-config-value">
                        <div class="col-md-4 disabled-item">
                            <div class="data-value" [ngClass]="{'disabledLink': ! isClientSelected}">
                                {{udpDataBaseName}}</div>
                        </div>
                        
                        <div class="col-md-4">
                            <div class="data-value"
                            [ngClass]="{'disabledLink': ! isTBAClient || ! isClientSelected}">
                            {{getTBALifecycleName(tbaLifeCycle)}}</div>
                        </div>
                           
                        <div class="col-md-4">
                            <div class="data-value"
                                [ngClass]="{'disabledLink': ! isTBAClient || ! isClientSelected}">{{transId}}
                            </div>
                        </div>    
                    </div>
                   
                </div>
                <div class="section-divider"></div>
                <div class="row">

                    <div class="col-md-12">
                        <h6>Change Configurations</h6>
                    </div>
                </div>
                <div class="row">

                    <div class="col-md-12">
                        <h4>Current Configurations</h4>
                    </div>
                </div>
                <div class="current-section">
                    <div class="row current-config-label">
                        <div class="col-md-4">
                            <div class="data-label" [ngClass]="{'disabledLink': ! isClientSelected}">UDP Database</div>
                           
                        </div>
                        <div class="col-md-4">
                            <div class="data-label"
                                [ngClass]="{'disabledLink': ! isTBAClient || ! isClientSelected}">TBA Lifecycle
                            </div>
                            
                        </div>
                        <div class="col-md-4 disabledItem">
                            <div class="data-label"
                                [ngClass]="{'disabledLink': ! isTBAClient || ! isClientSelected}">Trans ID</div>
                            
                        </div>
                    </div>
                    <div class="row current-config-value">
                        <div class="col-md-4">
                            <div class="data-value" [ngClass]="{'disabledLink': ! isClientSelected}">
                                {{crrUdpDataBaseName}}</div>
                        </div>
                        <div class="col-md-4">
                            <div class="data-value"
                                [ngClass]="{'disabledLink': ! isTBAClient || ! isClientSelected}">
                                {{getTBALifecycleName(crrTbaLifeCycle)}}</div>
                        </div>
                        <div class="col-md-4 disabledItem">
                            <div class="data-value"
                                [ngClass]="{'disabledLink': ! isTBAClient || ! isClientSelected}">
                                {{crrTransId}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">

                    <div class="col-md-12 new-config">
                        <p><strong>New Configurations </strong></p><button title="Reset to default"
                            (click)="resetToDefault()" [attr.tabIndex]="!rootService.dataBaseSelecterMap?.[databaseSelectorForm.value?.clientId]?-1:''"
                            [ngClass]="{'disabledLink': !rootService.dataBaseSelecterMap?.[databaseSelectorForm.value?.clientId]}">(Reset
                            to default)</button>
                    </div>
                </div>
                <div class="row  new-config-fields" [ngClass]="{'disabledLink': ! isClientSelected}">
                    <div class="col-*">
                        <mat-form-field appearance="fill" class="component-box">
                            <mat-label [ngClass]="{'disabledLink': ! isClientSelected}">UDP Database</mat-label>
                            <input [disabled]='!disable' matInput formControlName="udpDatabaseName" id="UDP Database"
                                class="pointer-events: none;"  [attr.tabIndex]="!isClientSelected?-1:''" />
                            <mat-error *ngIf="databaseSelectorForm.get('udpDatabaseName')?.hasError('udpDatabaseNameRegex')">
                                Schema names ending with 'x' are not allowed in Dev or QA environments.
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-*" [ngClass]="{'disabledLink': ! isTBAClient || ! isClientSelected}"  >
                        <mat-form-field appearance="fill" class="component-box" >
                            <mat-label [ngClass]="{'disabledLink': ! isTBAClient || ! isClientSelected}">TBA
                                Lifecycle</mat-label>
                            <mat-select formControlName="tbaLifeCycle" [disabled]="! isTBAClient || ! isClientSelected"  >
                                <mat-option *ngFor="let vaidValues of rootService.tbaguiLifeCycleList" [value]="vaidValues.fieldValue"  >
                                    {{ vaidValues.fieldValueDescription }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-*" [ngClass]="{'disabledLink': ! isTBAClient ||  ! isClientSelected}">
                        <mat-form-field appearance="fill" class="component-box">
                            <mat-label [ngClass]="{'disabledLink': ! isTBAClient ||  ! isClientSelected}">Trans
                                ID</mat-label>
                            <input [disabled]='!disable' matInput formControlName="transId" id="Trans ID"
                            [attr.tabIndex]="!isTBAClient || !isClientSelected?-1:''"/>
                        </mat-form-field>
                    </div>
                    <div class="col-md-* delete-section hide">
                        <button mat-icon-button class="delete-btn" title="Delete">
                            <f-icon icon-config='{"iconName": "trash-can", "iconType": "light", "iconSize": "s"}'></f-icon>
                    </button>
                    </div>               
                    
                </div>
                <div class="row flex add-new-fields hide">
                    <button mat-button color="primary" class="add-btn" title="Add">
                        <f-icon icon-config='{"iconName": "plus", "iconType": "solid", "iconSize": "s"}'></f-icon>
                        <span>Add</span>
                      </button>
                </div>
                
                
                
            </div>
        </div>
    </form>

    <div class="button-controls">
        <f-button text="Close" title="Close" type="button" variant="action" (click)="closeDatabaseSelector()" >
        </f-button>
        <f-button text="Submit" title="Submit" [ngClass]="{disableBtn:(! isClientSelected || databaseSelectorForm?.invalid)}" [disabled]="! isClientSelected || databaseSelectorForm?.invalid" type="button"
            variant="progressive" (click)="submitDbChange()"></f-button>
    </div>



</div>